<template>
    <main :class="['ui-data-list', preset ? `ui-data-list--${preset}` : null, type ? `ui-data-list--${type}` : null]">
        <table class="ui-data-list__table">
            <thead v-if="tableHeader && tableHeader.length">
                <tr>
                    <th v-if="hasCheckBox" class="ui-data-list__col__checkbox">
                        <input type="checkbox" />
                    </th>
                    <th v-for="row in tableHeader">{{ row }}</th>
                    <th v-if="typeof dropdown !== 'undefined'" class="ui-data-list__col__dropdown no-overflow-hidden"></th>
                </tr>
            </thead>
            <tbody v-if="list.length">
                <tr v-for="(row, index) in cached" @click="() => onClick(row)" :class="[selectedClass(row, index), !row.onClick ? 'no-click' : '']">
                    <td v-if="hasCheckBox" class="ui-data-list__col__checkbox">
                        <input type="checkbox" />
                    </td>
                    <template v-if="Array.isArray(row)">
                        <td v-for="(column, columnIndex) in row" :class="[typeof column === 'number' ? 'monospaced' : '']">
                            <app-icon v-if="columnIndex === 0" :tools="tools" :name="preset" />
                            {{ column }}
                        </td>
                    </template>
                    <template v-else>
                        <td v-for="(column, columnIndex) in row.items" :class="[typeof column === 'number' ? 'monospaced' : '', typeof column === 'object' && column.classes ? column.classes : null]">
                            <app-icon v-if="columnIndex === 0" :tools="tools" :name="preset" />
                            {{ (column && column.text) ? column.text : column }}
                        </td>
                    </template>
                    <td v-if="typeof dropdown !== 'undefined'" class="ui-data-list__col__dropdown no-overflow-hidden">
                        <ui-dropdown :list="dropdown(row)" />
                    </td>
                </tr>
            </tbody>
        </table>
    </main>
</template>

<script>
    import generator from '../../helpers/generator';
    import tableOptions from '../../dummy/data-list';
    import Chance from 'chance';
    const chance = new Chance();

    export default {
        name: 'ui-data-list',
        props: ['items', 'header', 'itemCount', 'tools', 'preset', 'row', 'selected', 'type', 'cache', 'maxItems', 'minItems', 'sortBy', 'hasCheckBox', 'includeInList', 'dropdown'],
        mounted() {
            this.cachedList = this.list;
        },
        data() {
            return {
                cachedList: [],
                hasSelected: false,
            };
        },
        computed: {
            getItemCount() {
                const { minItems, maxItems, itemCount } = this;

                if (minItems && maxItems) {
                    return chance.natural({ min: minItems, max: maxItems});
                }

                if (itemCount) {
                    return itemCount;
                }

                // Default
                return 5;
            },
            cached() {
                let renderList = this.cachedList;
                if (this.cache === false) {
                    renderList = this.list;
                }

                return renderList.sort((a, b) => {
                    if (typeof a.sortBy !== 'undefined') {
                        if (a.sortBy < b.sortBy) {
                            return -1;
                        }
                        if (a.sortBy > b.sortBy) {
                            return 1;
                        }

                        // names must be equal
                        return 0;
                    }
                    return a;
                });
            },
            currentPaneContent() {
                return this.tools.currentView.data.pane;
            },
            tableOptions() {
                return tableOptions(this.tools);
            },
            list() {
                if (this.preset) {
                    return generator.randomList(this.preset, this.getItemCount, this.includeInList).map(this.tableRow);
                }

                if (this.items) {
                    return this.items;
                }

                return [];
            },
            tableHeader() {
                const { tableOptions, preset, type, header } = this;

                if (header) {
                    return header;
                }

                if (typeof preset === 'string' && typeof type === 'string' && typeof tableOptions[preset] !== 'undefined' && typeof tableOptions[preset][type] !== 'undefined') {
                    return tableOptions[preset][type].header;
                }

                return [];
            },
        },
        methods: {
            tableRow(data) {
                const { tableOptions, preset, type, header, row } = this;

                if (typeof row === 'function') {
                    return row(data);
                }

                if (typeof preset === 'string' && typeof type === 'string' && typeof tableOptions[preset] !== 'undefined' && typeof tableOptions[preset][type] !== 'undefined') {
                    return {
                        ...tableOptions[preset][type].row(data),
                        data,
                    };
                }

                return [];
            },
            onClick(row) {
                if (typeof row.onClick === 'function') {
                    row.onClick();
                }
            },
            selectedClass(row, i) {
                if (row.data && this.currentPaneContent && row.data.id === this.currentPaneContent.id) {
                    this.hasSelected = true;
                    return 'selected';
                } else if (this.selected === i && !this.hasSelected) {
                    return 'selected';
                }

                return null;
            },
        }
    };
</script>

<style>
.ui-data-list {
    width: 100%;
    text-align: left;
    /*Use monospaced numbers, aka Tabular Numerals (tnum)*/
    font-feature-settings: 'tnum';
    -webkit-font-feature-settings: 'tnum';
    -moz-font-feature-settings: 'tnum';
}

.ui-data-list__table__absorb {
    width: 100%;
}

.ui-data-list__table {
    width: 100%;
    /*max-width:calc(100vw - 600px - 200px);*/
}

.ui-data-list__table *{
    position:relative;
}

.ui-data-list__table td {
    white-space: nowrap;
    min-width: 24px;
    max-width:400px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /*vertical-align: middle;*/
}


.ui-data-list__table td:first-child,
.ui-data-list__table tr th:first-child {
    border-radius:6px 0 0 6px;
}
.ui-data-list__table td:last-child,
.ui-data-list__table tr th:last-child {
    width: 100%;
    border-radius:0 6px 6px 0;
}

.ui-data-list__table td:first-child:last-child,
.ui-data-list__table tr th:first-child:last-child {
    border-radius:6px;
}

.ui-data-list__table thead {
    font-weight: bold;
    /*background: rgba(0, 0, 0, 0.2);*/
    color: rgba(0,0,0,0.5);
}

.ui-data-list__table tbody tr.selected {
    background: rgba(0, 0, 0, 0.5) !important;
    color:#fff;
}

.ui-data-list__table tbody tr {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 7px;
    /*font-size: 13px;*/
    /*letter-spacing:0.04em;*/
    line-height:13px;
}

.ui-data-list__table tr td, .ui-data-list__table tr th {
    padding: 3px 10px 5px 10px;
    /*padding: 5px 10px 3px 10px;*/
    width: auto;
}

.ui-data-list__table tbody tr:not(.no-click):hover {
    cursor: pointer;
}

.ui-data-list__table tbody tr:not(.no-click):hover {
    background: rgba(0, 0, 0, 0.15);
}

.ui-data-list__table tbody tr:not(.no-click):active {
    background: rgba(43, 117, 187, 1) !important;
    color:#fff !important;
}

.ui-data-list__table tbody tr:not(.no-click):nth-child(even):hover {
    background: rgba(0, 0, 0, 0.1);
}

.ui-data-list__table tbody tr:nth-child(even) {
    background: rgba(0, 0, 0, 0.008);
}

.pane--results .monospaced{
    text-align:right;
}

.align-right {
    text-align: right;
}

.no-overflow-hidden {
    overflow: visible !important;
}

.ui-data-list__table td.ui-data-list__col__dropdown,
.ui-data-list__table tr.ui-data-list__col__dropdown {
    padding: 0 0 0 10px;
    vertical-align: middle;
}

.ui-data-list__col__checkbox {
    min-width: 0 !important;
}

.max-width-175 {
    max-width: 175px !important;
}

.ui-data-list.col-min-120 th {
    min-width: 120px;
}

</style>



// WEBPACK FOOTER //
// UiDataList.vue?1573b926